import { cn } from '@sunstone/ui';

interface UniphoreLogoProps {
  className?: string;
}

export function UniphoreLogo({ className }: UniphoreLogoProps) {
  return (
    <span className={cn('inline-block', className)}>
      <img
        src="/uniphore-logo-light.svg"
        alt="Uniphore"
        className="block h-full w-auto dark:hidden"
      />
      <img
        src="/uniphore-logo-dark.svg"
        alt="Uniphore"
        className="hidden h-full w-auto dark:block"
      />
    </span>
  );
}
